import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { ButtonComponent } from '@pure/hive';
import { IConversationMessage } from '../../model/conversation';
import { faAngleLeft, faAngleRight } from '@fortawesome/pro-light-svg-icons';

@Component({
    selector: 'copilot-response-selector',
    standalone: true,
    imports: [ButtonComponent],
    templateUrl: './response-selector.component.html',
    styleUrl: './response-selector.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ResponseSelectorComponent {
    @Input() message!: IConversationMessage;
    @Output() setVariation = new EventEmitter<number>();

    canMoveLeft(): boolean {
        return this.message.selectedVariationIndex > 0;
    }

    canMoveRight(): boolean {
        return this.message.selectedVariationIndex < this.message.variations.length - 1;
    }

    protected readonly faAngleLeft = faAngleLeft;
    protected readonly faAngleRight = faAngleRight;
}
